import {appConfig} from './appConfig';

export type AppEnvironment = 'DEV' | 'UAT' | 'PROD';
export type HeaderEnvironmentLabel = 'localhost' | 'dev' | 'test' | null;

function resolveHostname(hostnameOverride?: string): string {
    return (hostnameOverride ?? window.location.hostname).toLowerCase();
}

function isLocalhost(hostname: string): boolean {
    return hostname === 'localhost' || hostname === '127.0.0.1';
}

export function detectEnvironment(hostnameOverride?: string): AppEnvironment {
    const hostname = resolveHostname(hostnameOverride);
    if (isLocalhost(hostname)) return 'DEV';
    if (hostname.includes('-dev')) return 'DEV';
    if (hostname.includes('-uat')) return 'UAT';
    return 'PROD';
}

export function getHeaderEnvironmentLabel(hostnameOverride?: string): HeaderEnvironmentLabel {
    const hostname = resolveHostname(hostnameOverride);

    if (isLocalhost(hostname)) return 'localhost';

    const env = detectEnvironment(hostname);
    if (env === 'DEV') return 'dev';
    if (env === 'UAT') return 'test';

    return null;
}

export function shouldShowGitLabLink(hostnameOverride?: string): boolean {
    if (appConfig.header?.alwaysDisplayGitLab ?? false) {
        return true;
    }

    return detectEnvironment(hostnameOverride) === 'DEV';
}

export function shouldShowAllDocs(): boolean {
    return appConfig.header?.alwaysDisplayAllDocs ?? false;
}
